import styles from "./newCard.module.scss";
import { addPointsInText } from "../../helpers/app";
import { NewCardProps, SuggestedPrice } from "../../interfaces/components";
import { Link } from 'react-router-dom';
import Favorite from "../../containers/Favorite/FavoriteContainer";
import { Skeleton } from '@mui/material';
import { images } from "../../constants/images";
import { useState, useEffect } from 'react';
import { usePublicationDetail } from "../PublicationDetail/hooks/usePublicationDetail";
import StarIcon from '@mui/icons-material/Star';

const NewCard = ({
    user,
    item,
    className = '',
    navigation = '',
    pressFavorite,
    loading = false,
    redirect,
    onClickCard = () => { },
    showPrimaryDescription = false,
    showSecondaryDescription = false,
    dealerLogo = "",
    dealerships = false,
    hidePriceIndicator = false,
}: NewCardProps) => {

    const [localLiked, setLocalLiked] = useState(item?.liked);
    const [isUpdating, setIsUpdating] = useState(false);
    const [suggestedPriceItem, setSuggestedPriceItem] = useState<SuggestedPrice>();

    const hookData = usePublicationDetail({ publication: item });

    useEffect(() => {
        if (item?.vehicle_data) {
            const vehicleData = Array.isArray(item.vehicle_data) ? item.vehicle_data[0] : item.vehicle_data;
            if (vehicleData?.suggested_price) {
                if (vehicleData.suggested_price.min_price !== "0" && vehicleData.suggested_price.suggested_price !== "0" && vehicleData.suggested_price.max_price !== "0") {
                    setSuggestedPriceItem(vehicleData.suggested_price);
                }
            }
        }
    }, [item]);

    const getPriceCategoryPublication = (): "good" | "fair" | "high" => {
        if (!suggestedPriceItem) {
            return "fair";
        }

        const price = parseInt(item?.price || "0");
        const retake = parseInt(suggestedPriceItem?.min_price || "0");
        const sale = parseInt(suggestedPriceItem?.suggested_price || "0");
        const publicationPrice = parseInt(suggestedPriceItem?.max_price || "0");

        if (!retake || !sale || !publicationPrice) return "fair";

        if (price < (sale)) {
            return "good";
        }

        if (price > (sale + 1000000)) {
            return "high";
        }

        return "fair";
    };

    const handleChangeFavorite = async (event: any) => {
        event.preventDefault();
        if (user && pressFavorite && !loading && !isUpdating) {
            setIsUpdating(true);
            try {
                await pressFavorite();
                setLocalLiked(!localLiked);
            } finally {
                setIsUpdating(false);
            }
        }
    }

    useEffect(() => {
        setLocalLiked(item?.liked);
    }, [item?.liked]);

    const truncateText = (text: string, maxLength: number) => {
        if (!text) return '';
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    }

    return (
        <Link onClick={onClickCard} to={navigation} className={`${styles.card} ${className}`}>
            <div className={styles.imageContainer}>
                {loading ? (
                    <Skeleton animation="wave" variant="rounded" className={styles.imageCard} />
                ) : (
                    <img
                        loading="lazy"
                        src={(item?.pictures?.original?.[0]?.path || item?.pictures?.[0]?.path) ?? images.noImagePublication}
                        className={styles.imageCard}
                        alt={`${item?.title} ${item?.vehicle_data?.version ?? ""} año ${item?.primary_description}`}
                        title={`${item?.title} ${item?.vehicle_data?.version ?? ""} año ${item?.primary_description}`}
                    />
                )}
                {dealerLogo && (
                    <div className={styles.dealerLogo}>
                        <img src={dealerLogo} alt="Dealer logo" title="Dealer logo" />
                    </div>
                )}
                {!loading && item?.status_brief?.code === "sold_out" && (
                    <h3 className={dealerships ? styles.soldDealerships : styles.sold}>Vendido</h3>
                )}
                {!loading && item?.status_brief?.code === "reserved" && (
                    <h3 className={dealerships ? styles.reservedDealerships : styles.reserved}>Reservado</h3>
                )}
                {/* {!loading && item?.certified && (
                    <Certified className={styles.certified} />
                )} */}
                <Favorite
                    publication={item}
                    onPress={handleChangeFavorite}
                    id={item?.id_publication || item?._id}
                    liked={localLiked}
                    loading={loading}
                    redirect={redirect}
                    className={styles.favorite}
                />
            </div>
            <div className={styles.content}>
                <div className={styles.infoContainer}>
                    <div className={styles.mainInfo}>
                        <h2 className={styles.title}>{truncateText(item?.title, 28)}</h2>
                        {showPrimaryDescription && item?.vehicle_data?.version && (
                            <h3 className={styles.subtitle}>{truncateText(item?.vehicle_data?.version, 38)}</h3>
                        )}
                    </div>
                    {showSecondaryDescription && (
                        <div className={styles.details}>
                            <span className={styles.year}>{item?.primary_description || item?.year}</span>
                            <span className={styles.separator}>|</span>
                            <span className={styles.km}>{addPointsInText(item?.secondary_description)}km</span>
                        </div>
                    )}
                </div>

                <div className={styles.priceContainer}>
                    <span className={dealerships ? styles.priceDealerships : styles.price}>${addPointsInText(item?.price)}
                        {item?.detail?.iva && item?.condition === "new" && (
                            <p className={styles.textIva}>+ IVA</p>
                        )}
                    </span>
                    {!hidePriceIndicator && suggestedPriceItem && (suggestedPriceItem.min_price || suggestedPriceItem.suggested_price || suggestedPriceItem.max_price) && (
                        <div className={dealerships ? styles.priceIndicatorDealerships : styles.priceIndicatorMyPublication}>
                            {item?.opportunity === true ? (
                                <>
                                    <StarIcon
                                        className={styles.priceIcon}
                                        style={{ width: '16px', height: '16px', marginRight: '0px', color: '#7100FF', display: 'flex', alignItems: 'center' }}
                                    />
                                    <p style={{ padding: '0%', margin: '0%', marginTop: '3px',color: '#000000' }}>Oportunidad</p>
                                </>
                            ) : (getPriceCategoryPublication() === "good" || getPriceCategoryPublication() === "fair") && (
                                <>
                                    <img
                                        src={
                                            getPriceCategoryPublication() === "good"
                                                ? images.checkVerde
                                                : images.checkAmarillo
                                        }
                                        alt="Indicador de precio"
                                        title="Indicador de precio"
                                        className={styles.priceIcon}
                                        style={dealerships ? { width: '14px', height: '14px', marginRight: '2px' } : { width: '16px', height: '16px', marginRight: '4px' }}
                                    />
                                    {getPriceCategoryPublication() === "good"
                                        ? "Buen precio"
                                        : "Precio justo"}
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Link>
    );
}

export default NewCard;